module.exports = __webpack_public_path__ + "c43c300a0d442f623dd4dbb18fcffd09.svg";